module.exports = __webpack_public_path__ + "static/img/RS@2x.809d79fe.jpg";